export default {
  hostname: "https://main.workshubs.com",
};
